import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import debounce from "lodash/debounce";
import { FILESYSTEM_TYPE, S3_TYPE, GCS_TYPE, ABS_TYPE } from "archive/ArchiveStore";
import { OVH_TYPE, SYSELEVEN_TYPE } from "archive/logic/s3CompatibleProviders";
import { FormikFormGroup } from "components/common";
const StyledDiv = styled.div`
  margin: 10px 0;
`;
const ArchiveBackendOutputPathFieldGroup = ({ checkOutputPath, noPreview = false }) => {
  const { values: formValues, setFieldError } = useFormikContext();
  const [pathCheck, setPathCheck] = useState(null);
  const [pathError, setPathError] = useState(null);
  const _validateOutputPath = useCallback(
    (path) => {
      checkOutputPath(path).then((response) => {
        setPathCheck(response.result);
        setPathError(null);
      }).catch((error) => {
        try {
          setPathCheck(null);
          const errorMessage = error.additional.body.message;
          setPathError(errorMessage);
          setFieldError("settings.output_path", errorMessage);
        } catch {
          setPathCheck(null);
          setPathError(error.message);
          setFieldError("settings.output_path", error.message);
        }
      });
    },
    [checkOutputPath, setFieldError]
  );
  const _debouncedValidateOutputPath = debounce(_validateOutputPath, 500);
  const labelText = {
    [S3_TYPE]: "S3 Output base path",
    [OVH_TYPE]: "OVH Output base path",
    [SYSELEVEN_TYPE]: "SysEleven Output base path",
    [GCS_TYPE]: "GCS Output base path",
    [ABS_TYPE]: "Azure Blob Output base path",
    [FILESYSTEM_TYPE]: "Output base path"
  };
  const exampleText = {
    [S3_TYPE]: "S3 Output path preview",
    [OVH_TYPE]: "OVH Output path preview",
    [SYSELEVEN_TYPE]: "SysEleven Output path preview",
    [GCS_TYPE]: "GCS Output path preview",
    [ABS_TYPE]: "Azure Blob Output path preview",
    [FILESYSTEM_TYPE]: "Example output path"
  };
  const placeholder = {
    [S3_TYPE]: "/data/archives/example",
    [OVH_TYPE]: "/data/archives/example",
    [SYSELEVEN_TYPE]: "/data/archives/example",
    [GCS_TYPE]: "data/archives/example",
    [ABS_TYPE]: "data/archives/example",
    [FILESYSTEM_TYPE]: "/data/archives/example"
  };
  const helpText = {
    [S3_TYPE]: "Base path where the archives should be stored within the S3 bucket.",
    [OVH_TYPE]: "Base path where the archives should be stored within the OVH bucket.",
    [SYSELEVEN_TYPE]: "Base path where the archives should be stored within the SysEleven bucket.",
    [GCS_TYPE]: "Base path where the archives should be stored within the GCS bucket.",
    [ABS_TYPE]: "Base path where the archives should be stored within the Azure blob storage container.",
    [FILESYSTEM_TYPE]: "Base path where the archives should be stored."
  };
  const getPathError = () => pathError && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, "ERROR:"), " ", pathError);
  const _onChange = (event) => {
    _debouncedValidateOutputPath(event.target.value);
  };
  useEffect(() => {
    _validateOutputPath(formValues.settings.output_path);
  }, [formValues, _validateOutputPath]);
  return /* @__PURE__ */ React.createElement(StyledDiv, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.output_path",
      placeholder: placeholder[formValues.settings.type],
      label: /* @__PURE__ */ React.createElement("span", null, labelText[formValues.settings.type]),
      required: formValues.settings.type === FILESYSTEM_TYPE,
      help: /* @__PURE__ */ React.createElement("span", null, helpText[formValues.settings.type], " Can ", /* @__PURE__ */ React.createElement("strong", null, "only"), " be set on backend creation and not be changed later!"),
      labelClassName: "",
      error: getPathError(),
      wrapperClassName: "",
      onChange: _onChange,
      disabled: !!(formValues == null ? void 0 : formValues.id)
    }
  ), !noPreview && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, exampleText[formValues.settings.type], ":"), /* @__PURE__ */ React.createElement("code", null, pathCheck)));
};
export default ArchiveBackendOutputPathFieldGroup;
